export default __webpack_public_path__ + "static/media/TransactionIconSiderClicked.d451fb4d.svg";